import { render, staticRenderFns } from "./AcompanharEnvioNaoLogado.vue?vue&type=template&id=51758681"
import script from "./AcompanharEnvioNaoLogado.vue?vue&type=script&lang=js"
export * from "./AcompanharEnvioNaoLogado.vue?vue&type=script&lang=js"
import style0 from "./AcompanharEnvioNaoLogado.vue?vue&type=style&index=0&id=51758681&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCardText})
